import axios from '../utils/axios';
export const addMedicationDispense = (body) => {
    return axios.post('/prod/fhir/MedicationDispense', JSON.stringify(body)).then((response) => {
        return response;
    });
};
